// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"g4-z"};